/* tslint:disable */
/* eslint-disable */
/**
 * mindd-payhub-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ContractFeeDto } from './contract-fee-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { MeteredFeeDto } from './metered-fee-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { PackageFeeDto } from './package-fee-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { PaymentTransactionDto } from './payment-transaction-dto';

/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * Invoice ID. DRAFT (preview) invoices use \'draft-{orgId}-{yyyy-MM}\' format; persisted invoices use UUID.
     * @type {string}
     * @memberof InvoiceDto
     */
    'id': string;
    /**
     * 조직 ID
     * @type {number}
     * @memberof InvoiceDto
     */
    'orgId': number;
    /**
     * 청구월 (yyyy-MM) — 발행/청구 기준 월. 내부 사용월은 yearMonth - 1
     * @type {string}
     * @memberof InvoiceDto
     */
    'yearMonth': string;
    /**
     * 청구 시작일 (KST)
     * @type {string}
     * @memberof InvoiceDto
     */
    'rangeStartDate': string;
    /**
     * 청구 종료일 (KST)
     * @type {string}
     * @memberof InvoiceDto
     */
    'rangeEndDate': string;
    /**
     * 총 청구 금액 (VAT 포함)
     * @type {number}
     * @memberof InvoiceDto
     */
    'totalAmount': number;
    /**
     * 최초 정산금액 (VAT 포함, 조정 이전 기준)
     * @type {number}
     * @memberof InvoiceDto
     */
    'originalTotalAmount': number;
    /**
     * 총 청구 부가세
     * @type {number}
     * @memberof InvoiceDto
     */
    'totalVat': number;
    /**
     * 총 청구 공급가액 (VAT 미포함)
     * @type {number}
     * @memberof InvoiceDto
     */
    'totalSupplyAmount': number;
    /**
     * 청구 상태
     * @type {string}
     * @memberof InvoiceDto
     */
    'billingStatus': InvoiceDtoBillingStatusEnum;
    /**
     * 결제 상태
     * @type {string}
     * @memberof InvoiceDto
     */
    'paymentStatus': InvoiceDtoPaymentStatusEnum;
    /**
     * 상태 변경 시각
     * @type {string}
     * @memberof InvoiceDto
     */
    'statusModifiedAt': string;
    /**
     * 계약 기반 과금 항목 목록
     * @type {Array<ContractFeeDto>}
     * @memberof InvoiceDto
     */
    'contractFees': Array<ContractFeeDto>;
    /**
     * 종량제 과금 항목 목록
     * @type {Array<MeteredFeeDto>}
     * @memberof InvoiceDto
     */
    'meteredFees': Array<MeteredFeeDto>;
    /**
     * 패키지 과금 항목 목록
     * @type {Array<PackageFeeDto>}
     * @memberof InvoiceDto
     */
    'packageFees': Array<PackageFeeDto>;
    /**
     * 결제 트랜잭션 목록
     * @type {Array<PaymentTransactionDto>}
     * @memberof InvoiceDto
     */
    'paymentTransactions': Array<PaymentTransactionDto>;
}

export const InvoiceDtoBillingStatusEnum = {
    Draft: 'DRAFT',
    Issued: 'ISSUED',
    Adjusted: 'ADJUSTED',
    Waived: 'WAIVED'
} as const;

export type InvoiceDtoBillingStatusEnum = typeof InvoiceDtoBillingStatusEnum[keyof typeof InvoiceDtoBillingStatusEnum];
export const InvoiceDtoPaymentStatusEnum = {
    None: 'NONE',
    Processing: 'PROCESSING',
    Paid: 'PAID',
    Failed: 'FAILED',
    Canceling: 'CANCELING'
} as const;

export type InvoiceDtoPaymentStatusEnum = typeof InvoiceDtoPaymentStatusEnum[keyof typeof InvoiceDtoPaymentStatusEnum];


